<template>
  <section class="list">
    <div class="row">
      <article
        class="card"
        v-for="format in formats"
        :key="format.id || format.name"
        @click="selectItem(format)"
      >
        <img
          :src="defaultFormatImage"
          class="card-image"
          :alt="`Imagen de ${format.name}`"
        />
        <h3>{{ format.name }}</h3>
        <!-- Nombre del formato -->
      </article>
    </div>
  </section>
</template>

<script>
import defaultImage from "@/assets/img/formato/formato.jpeg"; // Importa una imagen por defecto por si el formato no tiene una imagen asociada

export default {
  name: "ListFormats",
  // Recibimos la finca seleccionada
  props: {
    finca: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formats: [],
      defaultFormatImage: defaultImage,
    };
  },
  // Observa los cambios en la finca recibida para actualizar los formatos
  watch: {
    finca: {
      immediate: true,
      handler(newVal) {
        const all = Array.isArray(newVal.formats) ? [...newVal.formats] : [];
        this.formats = this.sortFormats(all);
      },
    },
  },

  methods: {
    sortFormats(formats) {
      const normalized = (value) =>
        String(value || "")
          .trim()
          .toUpperCase();

      const totalG = [];
      const totalKg = [];
      const others = [];

      formats.forEach((format) => {
        const name = normalized(format.name);
        if (name === "TOTAL (G)") {
          totalG.push(format);
          return;
        }
        if (name === "TOTAL (KG)") {
          totalKg.push(format);
          return;
        }
        others.push(format);
      });

      return [...totalG, ...totalKg, ...others];
    },

    selectItem(format) {
      this.$root.$emit("format", format);
    },
  },
};
</script>
